import request from '@/utils/request'
//search5000List
export function search5000List(param) {
    let data = param
    return request({
      url: `/v20/search5000List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}
//getShipNo
export function getShipNo(param) {
    let data = param
    return request({
      url: `/v20/getShipNo`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}  
//getTugBoat
export function getTugBoat(param) {
  let data = param
  return request({
    url: `/v20/getTugBoat`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  
//getPlace
export function getPlace(param) {
  let data = param
  return request({
    url: `/v20/getPlace`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//getPurpose
export function getPurpose(param) {
  let data = param
  return request({
    url: `/v20/getPurpose`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//getEmpNo
export function getEmpNo(param) {
  let data = param
  return request({
    url: `/v20/getEmpNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//getAlreadyConfirm
export function getAlreadyConfirm(param) {
  let data = param
  return request({
    url: `/v20/getAlreadyConfirm`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

// New/modify Tug-Boat
export function createTugBoat(param) {
  let data = param
  console.log('param', param)
  return request({
    url: `/v20/createTugBoat`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
//save01
export function save01(param) {
  let data = param
  console.log('param', param)
  return request({
    url: `/v20/save01`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

//delete1
export function delete1(param) {
  let data = param
  console.log('param', param)
  return request({
    url: `/v20/delete1`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// Delete Tug Boat
export function deleteTugBoat(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/deleteTugBoat`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// confirmSign
export function confirmSign(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/confirmSign`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// Coppy Tug-Boat
export function copyTugboat(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/copyTugboat`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// Count Tug-Boat
export function tugBoatCnt(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/tugBoatCnt`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
 
